import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'reactstrap';

//import images
import avatar from '../../assets/images/users/user-dummy-img.jpg';
import { createSelector } from 'reselect';
import { useNavigate } from 'react-router-dom';

const ProfileDropdown = () => {
	const profiledropdownData = createSelector(
		state => state.Profile.user,
		user => user
	);

	const navigate = useNavigate();

	// Inside your component
	const user = useSelector(profiledropdownData);

	const [userName, setUserName] = useState('Admin');

	useEffect(() => {
		if (localStorage.getItem('authUser')) {
			const obj = JSON.parse(localStorage.getItem('authUser'));
			// setUserName(
			// 	process.env.REACT_APP_DEFAULTAUTH === 'fake'
			// 		? obj.username === undefined
			// 			? user.full_name
			// 				? user.full_name
			// 				: obj.data.full_name
			// 			: 'Admin' || 'Admin'
			// 		: process.env.REACT_APP_DEFAULTAUTH === 'firebase'
			// 		? obj.email && obj.email
			// 		: 'Admin'
			// );
		}
	}, [userName, user]);

	//Dropdown Toggle
	const [isProfileDropdown, setIsProfileDropdown] = useState(false);
	const toggleProfileDropdown = () => {
		setIsProfileDropdown(!isProfileDropdown);
	};

	return (
		<React.Fragment>
			<Dropdown
				isOpen={isProfileDropdown}
				toggle={toggleProfileDropdown}
				className='ms-sm-3 header-item topbar-user'
			>
				<DropdownToggle tag='button' type='button' className='btn'>
					<span className='d-flex align-items-center'>
						<img
							id='avatar'
							className='rounded-circle header-profile-user'
							src={avatar}
							alt='Header Avatar'
						/>
						<span className='text-start ms-xl-2'>
							<span className='d-none d-xl-inline-block ms-1 fw-medium user-name-text'>
								{user?.full_name?.toUpperCase() || ''}
							</span>
							<span className='d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text'>
								{user?.role_name}
							</span>
						</span>
					</span>
				</DropdownToggle>
				<DropdownMenu className='dropdown-menu-end'>
					<h6 className='dropdown-header'>Bienvenido {user.full_name}!</h6>
					<DropdownItem onClick={() => navigate('/profile')}>
						<i className='mdi mdi-account-circle text-muted fs-16 align-middle me-1'></i>
						<span className='align-middle'>Perfil</span>
					</DropdownItem>
					{/* <DropdownItem href={process.env.PUBLIC_URL + '/apps-chat'}>
						<i className='mdi mdi-message-text-outline text-muted fs-16 align-middle me-1'></i>{' '}
						<span className='align-middle'>Messages</span>
					</DropdownItem>
					<DropdownItem href={process.env.PUBLIC_URL + '#'}>
						<i className='mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1'></i>{' '}
						<span className='align-middle'>Taskboard</span>
					</DropdownItem> */}
					{/* <DropdownItem href={process.env.PUBLIC_URL + '/faqs'}>
						<i className='mdi mdi-lifebuoy text-muted fs-16 align-middle me-1'></i>{' '}
						<span className='align-middle'>Ayuda</span>
					</DropdownItem> */}
					<div className='dropdown-divider'></div>
					<DropdownItem onClick={() => navigate('/privacy-policy')}>
						<i className={`${Icons.policy} text-muted fs-16 align-middle me-1`}></i>{' '}
						<span className='align-middle'>Política de Privacidad</span>
					</DropdownItem>
					{/* <DropdownItem href={process.env.PUBLIC_URL + '/terms-condition'}>
						<i className='ri-article-line text-muted fs-16 align-middle me-1'></i>{' '}
						<span className='align-middle'>Terminos y Condición</span>
					</DropdownItem> */}
					<div className='dropdown-divider'></div>
					{/* <DropdownItem href={process.env.PUBLIC_URL + '/pages-profile'}>
						<i className='mdi mdi-wallet text-muted fs-16 align-middle me-1'></i>{' '}
						<span className='align-middle'>
							Balance : <b>$5971.67</b>
						</span>
					</DropdownItem> */}
					{/* <DropdownItem
						href={process.env.PUBLIC_URL + '/pages-profile-settings'}
					>
						<i className='mdi mdi-cog-outline text-muted fs-16 align-middle me-1'></i>{' '}
						<span className='align-middle'>Configuración</span>
					</DropdownItem> */}
					<DropdownItem onClick={() => navigate('/logout')}>
						<i className='mdi mdi-logout text-muted fs-16 align-middle me-1'></i>{' '}
						<span className='align-middle' data-key='t-logout'>
							Cerrar sesión
						</span>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

export default ProfileDropdown;
